import { resolveHabitIcon } from "./habit-icon-map";
import styles from "./habit-icon.module.scss";

import type { CSSProperties } from "react";

/** Decorative alongside visible labels; stored emoji IDs never reach the rendered UI. */
export function HabitIcon({
  value,
  size = 28,
  className,
  theme,
}: {
  value: string;
  size?: number;
  className?: string;
  theme?: "light" | "dark" | "amoled";
}) {
  const { glyph: Glyph, color, artwork } = resolveHabitIcon(value);
  const style: CSSProperties = { width: size, height: size, color: `var(--icon-${color})` };
  return (
    <span className={`${styles.icon} ${className ?? ""}`} style={style} aria-hidden="true">
      {artwork && theme ? (
        <img
          src={`/art/${artwork}${theme === "light" ? "" : "-dark"}.webp`}
          width={size}
          height={size}
          alt=""
        />
      ) : artwork ? (
        <>
          <img
            className={styles.light}
            src={`/art/${artwork}.webp`}
            width={size}
            height={size}
            alt=""
          />
          <img
            className={styles.dark}
            src={`/art/${artwork}-dark.webp`}
            width={size}
            height={size}
            alt=""
          />
        </>
      ) : (
        <Glyph size={size} weight="duotone" />
      )}
    </span>
  );
}
